export const PERMISSIONS = {
  VIEW_ACTIVITY: 'view_activity',
  UPDATE_DELIVERIES: 'update_deliveries'
}

export const FULFILLMENT_TYPES = {
  IN_STORE: 'In-Store',
  PICK_UP: 'Pickup',
  DELIVERY: 'Delivery'
}

export const FLAG_TYPES = {
  NO_FLAG: 'No Flags',
  SYNC_ERROR: 'Needs Sync'
}

export const FLAG_FILTER_VALUES = Object.values(FLAG_TYPES)
